// src/pages/NotFound.tsx
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';

const NotFound: React.FC = () => {
  return (
    <Container className="text-center py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          {FaExclamationTriangle({ className: "text-warning", size: 80 })}
          <h1 className="mt-4 mb-3">404</h1>
          <h2 className="mb-4">Página não encontrada</h2>
          <p className="lead mb-5">
            A página que você está procurando não existe ou foi movida.
          </p>
          <Link to="/">
            <Button variant="primary" size="lg">
              {FaHome({ className: "me-2" })} Voltar para a página inicial
            </Button>
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;